import { toRefs, ref, computed, onMounted, onUnmounted } from 'vue';
import ProfileBtn from '../../btn/component-lib.esm3.js';
import BtnExpand from '../../shared/component-lib.esm.js';
import ChevronIcon from '../../../icons/arrows/component-lib.esm2.js';
import { getJotformId } from '../../../utils/embed/component-lib.esm4.js';

//
var script = {
  components: {
    BtnExpand,
    ProfileBtn,
    ChevronIcon
  },
  props: {
    url: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      default: null
    },
    formOptions: {
      type: Object,
      required: true
    },
    imageStyle: String,
    btnSize: String,
    variant: String,
    btnProps: Object
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      formOptions
    } = toRefs(props);
    const iframe = ref(null);
    const expand = ref(null);
    const hasBeenSubmitted = ref(false);
    const isOpen = ref(false);
    const formId = computed(() => {
      return getJotformId(props.url);
    });
    const isExpand = computed(() => {
      return formOptions.value.layout === 'expand';
    });
    onMounted(() => {
      window.addEventListener('message', handleMessage, false);
    });
    onUnmounted(() => {
      window.removeEventListener('message', handleMessage, false);
    });
    function handleClick() {
      if (isExpand.value) {
        if (!isOpen.value) emit('click');
        isOpen.value = !isOpen.value;
      } else emit('click');
    }
    async function handleMessage(e) {
      if (!iframe.value) return;

      // Form submit event
      if (e.data && e.data.action === 'submission-completed' && e.data.formID === formId.value && !hasBeenSubmitted.value) {
        emit('form-submit');
        hasBeenSubmitted.value = true;
      }
      if (typeof e.data === 'object') {
        return;
      }
      var args = e.data.split(':');
      switch (args[0]) {
        case 'scrollIntoView':
          iframe.value.scrollIntoView();
          break;
        case 'setHeight':
          iframe.value.style.height = args[1] + 'px';
          break;
        case 'collapseErrorPage':
          if (iframe.value.clientHeight > window.innerHeight) {
            iframe.value.style.height = window.innerHeight + 'px';
          }
          break;
        case 'exitFullscreen':
          if (window.document.exitFullscreen) window.document.exitFullscreen();else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
          break;
      }
    }
    return {
      iframe,
      expand,
      isExpand,
      isOpen,
      handleClick
    };
  }
};
export { script as default };